export enum PolygonType {
    Unknown,
	Circle,
	Rectangle,
	Custom,
}
